import { SESSION_STATUS } from "./constants/appointmentSessionConstants";
import uuidv4 from "uuid/v4";
import moment from "moment/moment";
import { getSessionSlotDuration } from "../components/utils/sessionUtilities";
import {getIntervalRrule, modifyRruleString} from '../components/utils/rruleUtils';

const getAppointmentSessionStatus = (sessObj) => {
  if (sessObj.active) return SESSION_STATUS?.ACTIVE;
  if (sessObj.locked) return SESSION_STATUS?.LOCKED;

  return SESSION_STATUS?.CANCELLED;
};

export const getDateWithHours = (date, hour) => moment(date).set({hours: moment(hour).hours(), minute: moment(hour).minute, seconds: 0, millisecond: 0});

const cleanSessionObj = (sessionObj) => {
    const newObj = {
        assignedSpecialty: sessionObj.assignedSpecialty,
        clinicsId: sessionObj.clinicsId,
        startDate: sessionObj.startDate,
        endDate: sessionObj.endDate,
        hospitalId: sessionObj.hospitalId,
        wardId: sessionObj.wardId,
        practitioner: sessionObj.practitioner,
        practitionerRole: sessionObj.practitionerRole,
        sessionName: sessionObj.sessionName,
        slotDurationInMinutes: sessionObj.slotDurationInMinutes,
        status: sessionObj.status,
        rrule: sessionObj.rrule,
        slotStartTime: sessionObj.slotStartTime,
    };

    if (sessionObj.healthCareService) {
        newObj.healthCareService = sessionObj.healthCareService;
    }

    return newObj;
}

export const createAppointmentSessionObject = (sessionState) => {
  return {
    sessionId: sessionState?.sessionId || sessionState?.id || uuidv4(),
    startDate: moment(sessionState.startDate)
      .set({
        hours: sessionState.startTime.hours(),
        minutes: sessionState.startTime.minutes(),
        seconds: 0,
        miliseconds: 0,
      })
      // .toISOString(),
      .toDate(),
    endDate: moment(sessionState.endDate)
      .set({
        hours: sessionState.endTime.hours(),
        minutes: sessionState.endTime.minutes(),
        seconds: 0,
        miliseconds: 0,
      })
      // .toISOString(),
      .toDate(),
    wardId: sessionState.wardId,
    hospitalId: sessionState.hospitalId,
    sessionName: sessionState.sessionName,
    clinicsId: sessionState.clinicsId ?? "",
    practitioner: sessionState.practitioner,
    practitionerRole: sessionState.practitionerRole,
    assignedSpecialty: sessionState.assignedSpecialty,
    status: getAppointmentSessionStatus(sessionState),
    rrule: getIntervalRrule(sessionState).toString(),
    slotStartTime: moment(sessionState.startTime).format("HH:mm"),
    slotDurationInMinutes: getSessionSlotDuration(sessionState),
  };
};

export const createUpdatedAppointmentSessionObject = (sessionState, existingAppointment) => {
    const updated = {};

    // if (existingAppointment.hospitalId) {
    //     updated.hospitalId = existingAppointment.hospitalId;
    // }

    // if (existingAppointment.wardId) {
    //     updated.wardId = existingAppointment.wardId;
    // }

    if (sessionState?.locked) {
        updated.status = 'LOCKED';
    }

    if (!sessionState?.active) {
        updated.status = 'CANCELLED';

        return updated;
    }

    if (!moment(sessionState.endDate).isSame(moment(existingAppointment.endDate))) {
        updated.endDate = moment(sessionState.endDate)
            .set({
                hours: sessionState.endTime.hours(),
                minutes: sessionState.endTime.minutes(),
                seconds: 0,
                miliseconds: 0,
            }).toDate();
        updated.rrule = modifyRruleString({...existingAppointment, endDate: updated.endDate});
    }

    if (sessionState?.sessionName !== existingAppointment.sessionName) {
        updated.sessionName = sessionState?.sessionName;
    }

    if (sessionState?.practitioner !== existingAppointment.practitioner) {
        updated.practitioner = sessionState?.practitioner;
    }

    return updated;
};

export const bulkCreateAppointmentSessionObjects = (sessionObj) => {
  return Object.keys(sessionObj?.customSessionTime).map((customSessionTimeKey) => {
      const dayOfWeekCustomTime = sessionObj?.customSessionTime?.[customSessionTimeKey];

    const newSessionObj = {
        ...sessionObj,
      startDate: moment(sessionObj.startDate)
        .set({
          hours: moment(dayOfWeekCustomTime.startTime).hours(),
          minutes: moment(dayOfWeekCustomTime.startTime).minutes(),
          seconds: 0,
          miliseconds: 0,
        }).toDate(),
      endDate: moment(sessionObj.endDate)
        .set({
          hours: moment(dayOfWeekCustomTime.endTime).hours(),
          minutes: moment(dayOfWeekCustomTime.endTime).minutes(),
          seconds: 0,
          miliseconds: 0,
        }).toDate(),
      wardId: sessionObj.wardId,
      hospitalId: sessionObj.hospitalId,
      sessionName: sessionObj.sessionName ?? "",
      clinicsId: sessionObj.clinicsId ?? "",
      practitioner: sessionObj.practitioner ?? "",
      practitionerRole: sessionObj.practitionerRole ?? "",
      assignedSpecialty: sessionObj.assignedSpecialty ?? "",
      status: getAppointmentSessionStatus(sessionObj),
      daysOfWeek: [customSessionTimeKey],
      slotStartTime: moment(dayOfWeekCustomTime.startTime).format("HH:mm"),
    };

    newSessionObj.rrule = getIntervalRrule(newSessionObj).toString();
    newSessionObj.slotDurationInMinutes = getSessionSlotDuration(newSessionObj);

    return cleanSessionObj(newSessionObj);
  });
};
